import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useInterfaceSisaf = () => {
  const [registroEnum, setRegistroEnum] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchRegistro = async () => {
      try {
        const response = await httpClient.get(
          `/api/taskssisdaf/interfacesisaf`,
        );

        const options = response.data.map(
          (registro: { value: number; label: string }) => ({
            value: registro.value.toString(),
            label: registro.label,
          }),
        );
        setRegistroEnum(options);
      } catch (error) {
        console.error('Erro ao buscar dados.', error);
      }
    };

    fetchRegistro();
  }, []);

  return registroEnum;
};
